import apiClient from './client';
import type {
  ApiResponse,
  UserInfo,
  UserListResponse,
  CreateUserRequest,
  UpdateUserRequest,
  UpdateUserRoleRequest,
} from './types';

const USERS_BASE = '/api/users';

/**
 * Get current authenticated user
 */
export async function getMe(): Promise<ApiResponse<UserInfo>> {
  const response = await apiClient.get<ApiResponse<UserInfo>>(`${USERS_BASE}/me`);
  return response.data;
}

/**
 * Get all users (admin only)
 */
export async function getUsers(): Promise<ApiResponse<UserListResponse>> {
  const response = await apiClient.get<ApiResponse<UserListResponse>>(USERS_BASE);
  return response.data;
}

/**
 * Get user by ID (admin only)
 */
export async function getUser(id: number): Promise<ApiResponse<UserInfo>> {
  const response = await apiClient.get<ApiResponse<UserInfo>>(`${USERS_BASE}/${id}`);
  return response.data;
}

/**
 * Create new user (admin only)
 */
export async function createUser(request: CreateUserRequest): Promise<ApiResponse<UserInfo>> {
  const response = await apiClient.post<ApiResponse<UserInfo>>(USERS_BASE, request);
  return response.data;
}

/**
 * Update user (admin only)
 */
export async function updateUser(
  id: number,
  request: UpdateUserRequest
): Promise<ApiResponse<UserInfo>> {
  const response = await apiClient.put<ApiResponse<UserInfo>>(`${USERS_BASE}/${id}`, request);
  return response.data;
}

/**
 * Update user role (admin only)
 */
export async function updateUserRole(
  id: number,
  request: UpdateUserRoleRequest
): Promise<ApiResponse<UserInfo>> {
  const response = await apiClient.put<ApiResponse<UserInfo>>(
    `${USERS_BASE}/${id}/role`,
    request
  );
  return response.data;
}

/**
 * Delete user (admin only)
 */
export async function deleteUser(id: number): Promise<ApiResponse> {
  const response = await apiClient.delete<ApiResponse>(`${USERS_BASE}/${id}`);
  return response.data;
}

export const usersApi = {
  getMe,
  getUsers,
  getUser,
  createUser,
  updateUser,
  updateUserRole,
  deleteUser,
};
